export const monthsArray = [
  "jan",
  "feb",
  "mar",
  "apr",
  "may",
  "jun",
  "jul",
  "aug",
  "sep",
  "oct",
  "nov",
  "dec",
];

export const workingHoursPerDay = 8;

export const detailedViewWidths = {
  revenue: {
    firstTable: [220, 160, 160, 160],
    secondTable: [
      { type: "TM", widths: [325, 325, 325, 325, 325, 229] },
      { type: "Cost Plus", widths: [250, 250, 250, 250, 250, 230] },
      { type: "FFP", widths: [250, 250, 250, 250, 250, 220] },
    ],
    thirdTable: [
      { type: "TM", widths: [400] },
      { type: "Cost Plus", widths: [400] },
      { type: "FFP", widths: [300] },
    ],
    fourtTable: [
      { type: "TM", widths: [320] },
      { type: "Cost Plus", widths: [320] },
      { type: "FFP", widths: [220] },
    ],
  },
  directLabor: {
    // Index 3 ("Is IWO?") sits between PN (index 2) and EMP ID / Sub ID (now index 4) —
    // every firstTable[n] reference for n >= 3 in CostPlus.js's Direct Labor table shifted up
    // by one when this was inserted.
    firstTable: [180, 65, 60, 70, 80, 100, 65, 100, 50],
    secondTable: [
      {
        type: "TM",
        widths: [
          92, 92, 92, 100, 92, 92, 92, 92, 92, 92, 92, 92, 92, 66, 92, 130, 194,
          160,
        ],
      },
      {
        type: "Cost Plus",
        widths: [
          89, 89, 92, 100, 92, 92, 92, 92, 92, 0, 0, 0, 0, 66, 92, 130, 194,
          160,
        ],
      },
      {
        type: "FFP",
        widths: [
          100, 100, 100, 100, 200, 100, 100, 100, 100, 0, 0, 0, 0, 100, 100, 0,
          150, 120,
        ],
      },
    ],
    thirdTable: [
      { type: "TM", widths: [100, 100, 100, 100] },
      { type: "Cost Plus", widths: [100, 100, 100, 100] },
      { type: "FFP", widths: [100, 100, 100] },
    ],
    fourtTable: [
      { type: "TM", widths: [120, 100, 100] },
      { type: "Cost Plus", widths: [120, 100, 100] },
      { type: "FFP", widths: [120, 100] },
    ],
  },
  otherDirectCosts: {
    firstTable: [240, 230, 230],
    secondTable: [
      { type: "TM", widths: [1334, 200, 200, 120] },
      { type: "Cost Plus", widths: [960, 200, 200, 120] },
      { type: "FFP", widths: [950, 200, 200, 120] },
    ],
    thirdTable: [
      { type: "TM", widths: [135, 135, 130] },
      { type: "Cost Plus", widths: [135, 135, 130] },
      { type: "FFP", widths: [150, 150, 0] },
    ],
    fourtTable: [
      { type: "TM", widths: [120, 100, 100] },
      { type: "Cost Plus", widths: [120, 100, 100] },
      { type: "FFP", widths: [120, 100, 0] },
    ],
  },
  margin: {
    firstTable: [700],
    secondTable: [
      { type: "TM", widths: [1854] },
      { type: "Cost Plus", widths: [1480] },
      { type: "FFP", widths: [1470] },
    ],
    thirdTable: [
      { type: "TM", widths: [135, 135, 130] },
      { type: "Cost Plus", widths: [135, 135, 130] },
      { type: "FFP", widths: [150, 150, 0] },
    ],
    fourtTable: [
      { type: "TM", widths: [120, 100, 100] },
      { type: "Cost Plus", widths: [120, 100, 100] },
      { type: "FFP", widths: [120, 100, 0] },
    ],
  },
};

export const pipelineUsers = [];

export const indirectHelpLinkUsers = [
  "christopher.auzmendi@agiledefense.com",
  "garrett.tong.ctr@agiledefense.com",
];
